import { Config } from "./types";

const config: Config = {
  amplify: {
    Auth: {
      Cognito: {
        userPoolId: "ap-southeast-1_5Ra7zeOr1",
        userPoolClientId: "60vil6kg692pqh9mnjbohu5seu",
        loginWith: {
          oauth: {
            domain: "ctv.auth.ap-southeast-1.amazoncognito.com",
            redirectSignIn: ["https://partners.ctv.traveloka.com/"],
            redirectSignOut: ["https://partners.ctv.traveloka.com/"],
            responseType: "code",
            scopes: ["email", "profile", "openid"],
          },
        },
      },
    },
  },
  apiHost: {
    affiliate: "https://user-api.afc.traveloka.com",
    affiliateStaging: "https://user-api.afc.staging-traveloka.com",
    partner: "https://partner-api.ctv.traveloka.com",
    partnerStaging: "https://partner-api.ctv.staging-traveloka.com",
    content: "https://api.cnt.traveloka.com/",
    data: "https://tracking.prod.tvlk-data.com/",
  },
  securePayment: "https://payfrm.pay.traveloka.com",
};

export default config;
